import { Form, message } from "antd";
import { getStationsList, saveUpdateStationListHandler, stationsListColumns } from "../utils";
import { useEffect, useState } from "react";
import { HomeTabKeyEnum, searchHandler } from "../../utils";
import { authAxios } from "../../utils/session_utils";

const useStationsListHook = () => {
	const [form] = Form.useForm();
	const [isStationFormOpen, setIsStationFormOpen] = useState<boolean>(false);
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const [stationEditId, setStationEditId] = useState<string>();
	const [stationsListData, setStationsListData] = useState<any[]>([]);
	const [searchQuery, setSearchQuery] = useState<string>("");
	const [timeoutId, setTimeoutId] = useState<NodeJS.Timeout | undefined>(undefined);

	useEffect(() => {
		if (location.pathname.includes(HomeTabKeyEnum.STATIONS)) {
			setIsLoading(true);
			getStationsListDataHandler({});
		}
	}, []);

	useEffect(() => {
		if (location.pathname.includes(HomeTabKeyEnum.STATIONS)) {
			setIsLoading(true);
			getStationsListDataHandler({ searchString: searchQuery });
		}
	}, [searchQuery]);

	const handleCancel = () => {
		setIsStationFormOpen(false);
		form.resetFields();
	};

	const editHelper = (record: any) => {
		form.setFieldsValue({ ...record });
		setStationEditId(record.id);
		setIsStationFormOpen(true);
	};

	const searchData = async () => {
		try {
			searchHandler(form, timeoutId, setTimeoutId, setSearchQuery);
		} catch (err) {
			console.error({ err });
		}
	};

	const deleteHandler = async (recordID: string) => {
		try {
			setIsLoading(true);
			const config = {
				method: "DELETE",
				url: `${process.env.REACT_APP_BACK_END_API}/snowflake/stations-list/${recordID}`,
			};
			const response = await authAxios(config);
			message.success(response.data.message);
			getStationsListDataHandler({});
		} catch (error) {
			message.error("Something went wrong in deleting the list");
			console.error(error);
			setIsLoading(false);
		}
	};

	const getStationsListDataHandler = async ({ searchString }: { searchString?: string }) => {
		const appliedSearchQuery = searchString ?? searchQuery;
		await getStationsList(setStationsListData, setIsLoading, appliedSearchQuery);
	};

	const saveUpdateStationsList = async () => {
		try {
			setIsLoading(true);
			const values: any = await form.validateFields();
			const data = {
				...values,
				id: stationEditId,
			};
			await saveUpdateStationListHandler(data, stationEditId);
			setIsStationFormOpen(false);
			form.resetFields();
			setStationEditId(undefined);
			getStationsListDataHandler({});
		} catch (error) {
			console.error(error);
			setIsLoading(false);
		}
	};

	return {
		stationsListColumns: stationsListColumns(editHelper, deleteHandler),
		isLoading,
		isStationFormOpen,
		setIsStationFormOpen,
		form,
		handleCancel,
		saveUpdateStationsList,
		searchData,
		stationEditId,
		stationsListData,
	};
};

export default useStationsListHook;
